import { Container, Stack } from "@mui/material";
import {
	Link,
	Navigate,
	Outlet,
	Route,
	Routes,
	useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import { MuiSetup } from "./MuiSetup";
import HomePage from "./pages/HomePage";
import IdentitiesPage from "./pages/IdentitiesPage";
import IdentityPage from "./pages/IdentityPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import ProfilePage from "./pages/ProfilePage";
import QuestsPage from "./pages/QuestsPage";
import RegisterIdentityPage from "./pages/RegisterIdentityPage";
import RewardsAdminPage from "./pages/RewardsAdminPage";
import MonitoringPage from "./pages/MonitoringPage";
import GrantPointsPage from "./pages/GrantPointsPage";
import { Providers } from "./providers";
import "./App.css";
import { useEffect } from "react";

import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

function ScrollToTop() {
	const { pathname } = useLocation();

	// biome-ignore lint/correctness/useExhaustiveDependencies: scroll on pathname change
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
}

function RootIndexPage() {
	const { search } = useLocation();
	const queryParams = new URLSearchParams(search);

	const hasRegisterParams =
		queryParams.has("encryption_pk") ||
		queryParams.has("signature_pk") ||
		queryParams.has("node_address");

	if (hasRegisterParams) {
		return <Navigate to={`/register${search}`} replace />;
	}

	return <HomePage />;
}

export default function App() {
	return (
		<>
			<Routes>
				<Route path="/" element={<Layout />}>
					<Route index element={<RootIndexPage />} />
					<Route path="profile" element={<ProfilePage />} />
					<Route path="quests" element={<QuestsPage />} />
					<Route path="identities" element={<IdentitiesPage />} />
					<Route path="leaderboard" element={<LeaderboardPage />} />
					<Route
						path="identity"
						element={<Navigate to="/identities" replace />}
					/>
					<Route path="identity/:identity" element={<IdentityPage />} />
					<Route path="register" element={<RegisterIdentityPage />} />
					<Route path="rewards" element={<RewardsAdminPage />} />
					<Route path="rewards/grants" element={<GrantPointsPage />} />
					<Route path="monitoring" element={<MonitoringPage />} />

					{/* Using path="*"" means "match anything", so this route
                acts like a catch-all for URLs that we don't have explicit
                routes for. */}
					<Route path="*" element={<NoMatch />} />
				</Route>
			</Routes>
		</>
	);
}

function Layout() {
	return (
		<MuiSetup>
			<Providers>
				<ScrollToTop />
				<Navbar />
				<div className="pt-[130px] min-h-100vh flex flex-col mx-auto max-w-7xl  flex-grow">
					<Outlet />
				</div>
				<Footer />
				<Toaster />
			</Providers>
		</MuiSetup>
	);
}

function NoMatch() {
	return (
		<Container>
			<Stack sx={{ alignItems: "center" }}>
				<h2>Nothing to see here!</h2>
				<p>
					<Link to="/">Go to the home page</Link>
				</p>
			</Stack>
		</Container>
	);
}
